import { Popover, PopoverButton, PopoverPanel, Transition } from '@headlessui/react';
import { InformationCircleIcon, XMarkIcon } from '@heroicons/react/20/solid';
import { Fragment } from 'react';
import { twMerge } from 'tailwind-merge';

import { CircleButton, ForwardedCircleButton } from './CircleButton';
import { Heading } from './Heading';
import { Para } from './Para';
import { Stack } from './Stack';

type InfoButtonProps = {
  className?: string;
  iconClasses?: string;
  text: React.ReactNode;
  title: React.ReactNode;
};

export function InfoButton({
  title,
  text,
  iconClasses,
  className,
}: InfoButtonProps): React.ReactElement {
  const classNames = twMerge(
    'absolute left-1/2 w-screen max-w-sm -translate-x-1/2 transform px-4 mt-10',
    'text-zinc-700',
    className,
  );

  return (
    <Popover className="sm:relative flex items-center">
      <PopoverButton as={ForwardedCircleButton}>
        <InformationCircleIcon className={twMerge('size-5', iconClasses)} />
      </PopoverButton>

      <Transition
        as={Fragment}
        enter="transition ease-out duration-200"
        enterFrom="opacity-0 translate-y-1"
        enterTo="opacity-100 translate-y-0"
        leave="transition ease-in duration-150"
        leaveFrom="opacity-100 translate-y-0"
        leaveTo="opacity-0 translate-y-1"
      >
        <PopoverPanel className={classNames}>
          <Stack gap={2} className="bg-white p-4 shadow-lg text-left">
            <Stack direction="row" className="justify-between">
              <Heading variant="h5" align="left" className="font-semibold">
                {title}
              </Heading>
              <PopoverButton as={CircleButton} className="text-zinc-500">
                <XMarkIcon className="size-5" />
              </PopoverButton>
            </Stack>

            <Para size="sm" pretty>
              {text}
            </Para>
          </Stack>
        </PopoverPanel>
      </Transition>
    </Popover>
  );
}
